import { Fragment, useEffect, useState } from 'react';
import Spinner from 'react-bootstrap/Spinner';
import { BrowserRouter } from 'react-router-dom';

import { isEmpty } from '_dash';
import { getUserDetail } from 'actions';
import { AUTHORIZATION_KEY } from 'global_constants';

import AccountHook from 'hooks/account';
import ScrollToTop from 'components/scrollToTop';
import UserLocalStorageHook from 'hooks/userLocalstorage';
import AppRoutes from 'appRoutes';
import { HelpCrunchProvider } from 'context/helpCrunchContext';
import { IntercomProvider } from 'context/IntercomProvider';

// Floating Intercom Button Component

const App = ({ accountData, setAccountData }) => {
  const isLoggedIn = !isEmpty(accountData);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isEmpty(accountData)) {
      getUserDetail()
        .then((response) => {
          setAccountData(response);
          setLoading(false);
        })
        .catch((err) => {
          // Only clear auth token on failure, preserve other data like cart
          localStorage.removeItem(AUTHORIZATION_KEY);
          setLoading(false);
        });
    } else {
      // User is already logged in
      setLoading(false);
    }

    if (window.location) {
      const { origin, pathname, search } = window.location;
      if (origin && pathname) {
        if (pathname && pathname.length > 2) {
          const pathnameArray = pathname.split('/');
          let lowercaseUrl = pathnameArray
            .map((url, index) => {
              if (index < 2) {
                return url.trim().toLowerCase();
              }
              return url;
            })
            .join('/');
          lowercaseUrl = `${origin}${lowercaseUrl}${search ? search : ''}`;
          const currentUrl = window.location.href;
          if (currentUrl !== lowercaseUrl) {
            window.history.replaceState(null, null, lowercaseUrl);
          }
        }
      }
    }
  }, [accountData, setAccountData]);

  if (loading) {
    return (
      <div className='app-loader'>
        <Spinner animation='border' />
      </div>
    );
  }

  return (
    <BrowserRouter>
      <div style={{
        display: "none"
      }}>
        <IntercomProvider />
      </div>

      <HelpCrunchProvider accountData={accountData}>
        <Fragment>
          <ScrollToTop />
          <AppRoutes loading={loading} isLoggedIn={isLoggedIn} />

        </Fragment>
      </HelpCrunchProvider>
    </BrowserRouter>
  );
};

export default UserLocalStorageHook(AccountHook(App));
